module.exports = __webpack_public_path__ + "static/media/Company-Org-Illustration.f9339fc8.svg";